import FerryTimetable from './ferry_timetable';

export default FerryTimetable;
